;(function($) {

	if (!$("body").hasClass("home")) return;


	$(".slides-container").each(function(i, container) {

		console.log("set up slideshow in slides-container", container, i)

		// return; // debugging

		const slideCount = $(container).find('.slide').length - 1;
		let currentSlide = 0;

		setInterval(function() {
			if (currentSlide == slideCount) {
				currentSlide = 0;
			} else {
				currentSlide++;
			}
			setTimeout(function() {
				$(container).find('.slide.active').removeClass('active');
				$(container).find('.slide').eq(currentSlide).addClass('active');
			}, 300 * i);
				
		}, 4000);
			
	})

	

	
})(jQuery);